import { useEffect, useState } from "react";
import { InvoiceTypeFormat } from "../../models/EnumEntity";
import billingService from "../../services/billingService";
import { utils } from "../../utils/utils";

const mapInvoice = (invoice) => {
    if (!invoice) return null
    return {
        ...invoice,
        typeToShow: InvoiceTypeFormat[invoice.type],
        customer: invoice.customer,
        items: invoice?.items.map(i => ({
            ...i,
            amountToShow: utils.formatMoney(i.amount),
            priceToShow: utils.formatMoney(i.price)
        }))
    }
}
const useInvoice = (invoiceId) => {
    const [invoice, setInvoice] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getFromServer = async () => {
            setLoading(true)
            billingService
                .GetInvoice(invoiceId)
                .then(res => setInvoice(mapInvoice(res)))
                .finally(setLoading(false))
        }

        if (invoiceId) getFromServer()
    }, [invoiceId])

    return {
        invoice,
        loading
    }
}

export default useInvoice;